export enum SmartTagsEventType {
	SELECT_PHOTO,
	DELETE_SMART_TAG
}